import { render, staticRenderFns } from "./DialogEditGroup.vue?vue&type=template&id=3afb8dfe"
import script from "./DialogEditGroup.js?vue&type=script&lang=js&external"
export * from "./DialogEditGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports